import ProductIcon from '@mui/icons-material/Collections';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';

interface Props {
    value?: string;
}

const ImplementationOfActionPending = (props: Props) => {
    const { value } = props;
    const translate = useTranslate();
    return (
        <CardWithIcon
            to='/implementationOfAction?filter={"sendToResponsibleForImplementation":true,"sendToResponsibleForClosingOfActions":false,"implementationDate":null}'
            icon={ProductIcon}
            title={translate('resources.dashboard.implementationOfActionPending')}
            subtitle={value}
        />
    );
};

export default ImplementationOfActionPending;